import { Menu, MenuItem } from '@mui/material';
import { SyntheticEvent, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import burgerIcon from '../../assets/images/general/burger-icon.png';
import logoBlock from '../../assets/images/logo-block.png';
import { GameContext } from '../../core/context/game.context';
import './header.style.scss';
import { Languages } from '../../core/interfaces/misc.interface';

export const Header = () => {
  const gameCtx = useContext(GameContext);
  const selectedLng = gameCtx.getLanguage() || '';
  const location = useLocation();
  const [showLngSelector, setShowLngSelector] = useState<boolean>();
  const [aEState, setAEState] = useState<HTMLElement>();
  const menuOpened = !!aEState;
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    setShowLngSelector(location.pathname === '/' + selectedLng || location.pathname.includes('/tutorial'));
  }, [location, selectedLng]);

  const lngHandler = (e: SyntheticEvent<HTMLSelectElement> | Languages['language']) => {
    if ((e as SyntheticEvent<HTMLSelectElement>).currentTarget) {
      gameCtx.setLanguage((e as SyntheticEvent<HTMLSelectElement>).currentTarget.value as any);
    } else {
      gameCtx.setLanguage(e as Languages['language']);
      setAEState(null);
    }
  };

  const goLanding = () => {
    navigate('/');
  };

  return (
    <section className="HeaderComponent">
      {gameCtx.getInstance()?.name === 'autogrill' ? <div className='HeaderComponent__blocker' /> : null}
      <div className={'aligner' + (showLngSelector ? '' : ' aligner--fullWidth')}>
        <img src={logoBlock} alt="loquis challenge logo" className="logoBlock" onClick={goLanding} />
        <div className="aligner__inlineChild">
          <div className="aligner__inlineChild__rightElems">
            <div className="loquisDownload">
              <a href="https://link-to.app/Loquis" target="_blank" rel="noreferrer">
                {t('header.download')}
              </a>
            </div>
            {showLngSelector && (
              <select className="lngSelector" onChange={lngHandler} value={selectedLng}>
                <option value="it">{t('header.it')}</option>
                <option value="es">{t('header.es')}</option>
                <option value="en">{t('header.en')}</option>
              </select>
            )}
          </div>
        </div>
        <div className="aligner__burgerChild">
          <button style={{ border: 'none', background: 'none' }} onClick={(e) => setAEState(e.currentTarget)}>
            <img src={burgerIcon} alt="burger" width="31" />
          </button>
          <Menu
            id="basic-menu"
            anchorEl={aEState}
            open={menuOpened}
            onClose={() => setAEState(null)}
            className="aligner__burgerChild__rightElems"
          >
            <MenuItem>
              <a href="https://link-to.app/Loquis" onClick={() => setAEState(null)} target="_blank" rel="noreferrer">
                <span style={{ fontWeight: 600 }}>{t('header.download')}</span>
              </a>
            </MenuItem>
            {showLngSelector && [
              <MenuItem key="0" className="lngList" style={{ marginTop: '10px' }}>
                {t('header.choose-lng')}
              </MenuItem>,
              <MenuItem
                key="1"
                className={'lngList' + (gameCtx.getLanguage() === 'it' ? ' chosen' : '')}
                style={{ marginLeft: '20px' }}
                onClick={() => lngHandler('it')}
              >
                {t('header.it')}
              </MenuItem>,
              <MenuItem
                key="2"
                className={'lngList' + (gameCtx.getLanguage() === 'es' ? ' chosen' : '')}
                style={{ marginLeft: '20px' }}
                onClick={() => lngHandler('es')}
              >
                {t('header.es')}
              </MenuItem>,
              <MenuItem
                key="3"
                className={'lngList' + (gameCtx.getLanguage() === 'en' ? ' chosen' : '')}
                style={{ marginLeft: '20px' }}
                onClick={() => lngHandler('en')}
              >
                {t('header.en')}
              </MenuItem>,
            ]}
          </Menu>
        </div>
      </div>
    </section>
  );
};
